module.exports = __webpack_public_path__ + "static/media/paid_az.6d46b5c6.svg";